import { replaceKeysWithValues } from '@helpers/miscelleanous';
import { Image, Text } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import texts from './en.json';
import { useSearchParams } from 'next/navigation';
import useOpportunitiesStore from '../store/useOpportunitiesStore';
import { useStoreSelector } from '@ui/hooks/useStoreSelector';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { DESKTOP_LIMIT, MOBILE_LIMIT } from '../utils/constants';

export const ErrorHandler = ({
    data,
    error,
    loading,
    isFetchingActiveOpportunities,
    hasFilters,
}) => {
    const searchParams = useSearchParams();
    const { width } = useWindowDimensions();
    const queryParams = Object.fromEntries(searchParams.entries());
    const { fetchOpportunities } =
        useStoreSelector(useOpportunitiesStore, (state) => ({
            fetchOpportunities: state.fetchOpportunities,
        }));
    const handleRetry = () => {
        fetchOpportunities({
            ...queryParams,
            limit: width < 1280 ? MOBILE_LIMIT : DESKTOP_LIMIT,
        });
    };

    const handleInfiniteRetry = () => {
        fetchOpportunities({
            ...queryParams,
            type: error?.type,
            page: error?.page,
            limit: width < 1280 ? MOBILE_LIMIT : DESKTOP_LIMIT,
        });
    };

    const getButtonSize = () => (width < 768 ? 'extrasmall' : 'small');

    return !data.length ? (
        <div className="bg-basicWhite z-20 md:min-w-[480px] mx-auto flex flex-col gap-2 justify-center items-center text-center col-span-full p-6 rounded-xl shadow-sm my-4 md:my-8">
            <Image src="/images/ErrorFill.svg" className="w-[32] h-[32]" />
            <Text
                content={replaceKeysWithValues(
                    texts?.ErrorWhileFetchingFirstPage,
                    {
                        '{type}': hasFilters
                            ? 'filtered'
                            : isFetchingActiveOpportunities
                            ? 'active'
                            : 'closed',
                    }
                )}
                className="text-primary-500 h6-semibold"
            />
            <Text
                content="Please try again or refresh the page."
                className="p5-medium text-gray-700 mb-2"
            />
            <Button
                buttonText={texts?.TryAgain}
                buttonType="primary"
                onClick={handleRetry}
                buttonSize={getButtonSize()}
            />
        </div>
    ) : (
        <div className="z-20 md:min-w-[640px] w-full mx-auto flex flex-col gap-4 justify-center items-center text-center col-span-full p-6 my-8">
            <Image src="/images/ErrorFill.svg" className="w-[32] h-[32]" />
            <Text
                content={texts?.ErrorWhileFetchingMorePages}
                className="text-gray-500 p4-medium"
            />
            <Button
                isLoading={loading}
                buttonText={texts?.TryAgain}
                buttonType="primary"
                onClick={() => {
                    handleInfiniteRetry()
                }}
                type="button"
                buttonSize={getButtonSize()}
            />
        </div>
    );
}
